import { TZDate } from "@date-fns/tz";
import { format, getTime, formatDistanceToNow, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
// ----------------------------------------------------------------------

type InputValue = Date | string | number | null;

export function toDate(date: InputValue): Date {
  if (!date) return new Date("");
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return parseISO(date); // yyyy-MM-dd seguro
  }
  return new Date(date);
}

export function fDate(date: InputValue, newFormat?: string) {
  if (!date) return "";

  const fm = newFormat || "dd/MM/yyyy";

  // Se for string ISO, pega só a parte de data
  let d: Date;
  if (typeof date === "string") {
    const [year, month, day] = date.split("T")[0].split("-").map(Number);
    // mês no JS é 0-index
    d = new Date(year, month - 1, day);
  } else {
    d = new Date(date);
  }

  return format(d, fm, { locale: ptBR });
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || "dd MMM yyyy p";
  return date ? format(toDate(date), fm, { locale: ptBR }) : "";
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(toDate(date)) : "";
}

export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(toDate(date), { addSuffix: true, locale: ptBR })
    : "";
}

export function getMonthDateRange() {
  const now = new Date();

  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  const formatISO = (date: Date) => format(date, "yyyy-MM-dd");

  return {
    firstDay: formatISO(firstDay),
    lastDay: formatISO(lastDay),
  };
}

export function getNextMonthSameDay(qnt: number = 1) {
  const now = new Date();

  // Cria nova data com +1 mês
  const nextMonth = new Date(
    now.getFullYear(),
    now.getMonth() + qnt,
    now.getDate()
  );

  const formatISO = (date: Date) => format(date, "yyyy-MM-dd");

  return {
    firstDay: formatISO(now),
    lastDay: formatISO(nextMonth),
  };
}
